import ownerWindow from '@mui/utils/ownerWindow';
export default ownerWindow;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/ownerWindow.js
// module id = 311
// module chunks = 25